import { useRef } from 'react';
import IconifyIcon from '../IconifyIcon';
import { useAuth } from '../../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';

const ProfileDropdown = ({ isOpen, onToggle, onClose }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const touchStartY = useRef(0);

  // Handle touch swipe down to close
  const handleTouchStart = (e) => {
    touchStartY.current = e.touches[0].clientY;
  };

  const handleTouchMove = (e) => {
    const touchY = e.touches[0].clientY;
    const diff = touchY - touchStartY.current;
    if (diff > 50) {
      onClose();
    }
  };

  const handleLogout = () => {
    onClose();
    logout();
    navigate('/admin/login');
  };

  // Handle button click to toggle
  const handleButtonClick = (e) => {
    e.stopPropagation();
    if (isOpen) {
      onClose();
    } else {
      onToggle(true);
    }
  };

  return (
    <div className="topbar-item position-relative">
      <button
        type="button"
        className={`topbar-button ${isOpen ? 'active' : ''}`}
        onClick={handleButtonClick}
      >
        <span className="d-flex align-items-center">
          <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: 32, height: 32, backgroundColor: '#c5a05e' }}>
            <span className="text-white fw-bold">{user?.name?.charAt(0) || 'A'}</span>
          </div>
        </span>
      </button>
      
      {isOpen && (
        <>
          {/* Backdrop for closing */}
          <div 
            className="profile-backdrop"
            onClick={onClose}
            onTouchEnd={onClose}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0,0,0,0.4)',
              zIndex: 99998
            }}
          />
          
          {/* Dropdown Menu */}
          <div 
            className="profile-dropdown-menu show"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
          >
            <div className="profile-dropdown-header dropdown-header">
              <IconifyIcon icon="solar:user-circle-bold-duotone" className="me-2" style={{ fontSize: '20px', color: '#c5a05e' }} />
              Welcome {user?.name || 'Admin'}!
            </div>
            
            <Link to="/admin/profile" onClick={onClose} className="dropdown-item profile-dropdown-item">
              <IconifyIcon icon="solar:user-circle-bold-duotone" className="align-middle me-2" style={{ fontSize: '18px', color: '#c5a05e' }} />
              <span className="align-middle">Profile</span>
            </Link>
            <Link to="/admin/settings" onClick={onClose} className="dropdown-item profile-dropdown-item">
              <IconifyIcon icon="solar:settings-bold-duotone" className="align-middle me-2" style={{ fontSize: '18px', color: '#c5a05e' }} />
              <span className="align-middle">Settings</span>
            </Link>
            <Link to="/admin/help" onClick={onClose} className="dropdown-item profile-dropdown-item">
              <IconifyIcon icon="solar:question-circle-bold-duotone" className="align-middle me-2" style={{ fontSize: '18px', color: '#c5a05e' }} />
              <span className="align-middle">Help</span>
            </Link>
            <div className="dropdown-divider" />
            <button className="dropdown-item profile-dropdown-item logout-item" onClick={handleLogout}>
              <IconifyIcon icon="solar:logout-2-bold-duotone" className="align-middle me-2" style={{ fontSize: '18px' }} />
              <span className="align-middle">Logout</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ProfileDropdown;
